import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const containerCss = (isOpen: boolean, isApplicationsPage: boolean) => css`
  display: grid;
  align-content: baseline;
  grid-template-columns: ${isOpen ? '300px 1fr' : '1fr'};
  grid-template-rows: auto;
  height: ${`calc(100vh - ${isApplicationsPage ? 246 : 103}px)`};
  overflow-x: auto;
  overflow-y: hidden;
  background-color: ${theme.color.white};
`
const filterLinkCss = css`
  display: flex;
  align-items: center;
  margin-left: 25px;
`
const leftCss = (isOpen: boolean) => css`
  width: ${isOpen ? '300px' : '0px'};
  border-right: 1px ${theme.color.neutral40} solid;
  overflow-x: auto;
`
const childrenCss = (isApplicationsPage: boolean) => css`
  /* Autosizer requirements */
  display: grid;
  height: ${`calc(100vh - ${isApplicationsPage ? 370 : 220}px)`};
  overflow: auto;
`
const linkCss = css`
  display: flex;
  align-items: center;
  padding: 10px 0 10px 0;
  width: max-content;
`
const searchInputCss = css`
  input {
    padding: 8px 16px;
  }
`
const iconCss = (isOpen: boolean) => css`
  transform: ${isOpen ? 'rotate(-180deg)' : 'rotate(0)'};
  transition: transform ease 300ms;
`
const quickViewContainerCss = css`
  margin-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
`
const quickViewTitleCss = css`
  padding-bottom: 6px;
`
const headerContainerCss = css`
  display: flex;
  align-items: center;
  margin-left: 31px;
  margin-top: 24px;

  .ds-text-input {
    padding-top: 0;
  }
`
const headerTitleCss = css`
  margin-right: 16px;
`
const tabsContainerCss = css`
  display: flex;
  flex-grow: 5;
  justify-content: center;
`
const separatorCss = css`
  margin-bottom: 0;
`

export const layoutStyles = {
  containerCss,
  filterLinkCss,
  leftCss,
  childrenCss,
  linkCss,
  searchInputCss,
  iconCss,
  quickViewContainerCss,
  quickViewTitleCss,
  headerContainerCss,
  headerTitleCss,
  tabsContainerCss,
  separatorCss
}
